module.exports = __webpack_public_path__ + "static/media/varsity_flock_sheep.94b8af58.png";